import type { InvoicesV2QueryParams } from './types';

import { ENDPOINT } from '~/constants/endpoints';

import type { KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

import { withoutObjectKeysWhereValueIs } from '@vestigas/utils';

import {
  zodInvoicesV2QueryParamsSchema,
  zodInvoicesV2ResponseSchema,
} from './validations';

/**
 * Fetches a page of incoming invoices from the V2 invoice service.
 *
 * @param queryParams - Search, filter, sort, and pagination parameters.
 * @param options - Request options supplied by TanStack Query.
 * @returns A validated paginated invoice response.
 * @see https://app.dev.vestigas.com/redoc#tag/Invoices/operation/list_invoices_invoices_get
 */
export async function fetchInvoicesV2(
  queryParams: Partial<InvoicesV2QueryParams>,
  options?: KyRequestOptions,
) {
  return vestigasApi
    .get(ENDPOINT.INVOICE.GET_ALL_V2(), {
      ...options,
      searchParams: withoutObjectKeysWhereValueIs(queryParams, [
        null,
        undefined,
      ]) as Record<string, string | number | boolean | undefined>,
      validate: {
        searchParams: zodInvoicesV2QueryParamsSchema,
        response: zodInvoicesV2ResponseSchema,
      },
    })
    .json<unknown>();
}
